import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {KongService} from '../kong.service';
import {MatDialog} from '@angular/material';
import {interval} from 'rxjs';
import { environment } from 'src/environments/environment';
import {ConfService} from '../conf.service';
import {FooterComponent} from '../footer/footer.component';
import {AccountInfoService} from '../user/account-info.service';

@Component({
  selector: 'app-dataql-engine',
  templateUrl: './dataql-engine.component.html',
  styleUrls: ['./dataql-engine.component.scss']
})
export class DataqlEngineComponent implements OnInit {

  tabData: any;
  activeTabIndex: any;
  showDoc = false;
  paramsTobeSent: any;

  componentLoading = true;
  gatewayUrlDeploying = false;
  gatewayUrlExists = false;

  docData: any;
  data: any;
  defaultGatewayHost: string;
  // this.kong.getServicesFromApiGatewayByNameOrIdWithHost(this.defaultGatewayHost,

  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');

  dataQlApiName = 'dataql';
  dataQlApiVersion = 'v1';

  executor = {
    partner: localStorage.getItem('partner'),
    account_id: localStorage.getItem('partner'),
    executor_method_type: 'POST',
    apiUrl: '',
    dataroot: null,
    queryParams: [
      {
        'key': 'dbref',
        'value': 'false',
        'description': '',
        'req': false
      },
      {
        'key': 'limit',
        'value': '1000',
        'description': '',
        'req': false
      },
      {
        'key': 'offset',
        'value': '0',
        'description': '',
        'req': false
      },
      {
        'key': 'pagination',
        'value': 'false',
        'description': '',
        'req': false
      },
      {
        'key': 'self-links',
        'value': 'false',
        'description': '',
        'req': false
      },
      {
        'key': 'sort',
        'value': '',
        'description': '',
        'req': false
      }
    ],
    pathParams: [],
    headers: [
      {
        'key': 'Content-Type',
        'value': 'text/plain',
        'description': '',
        'req': false
      },
      {
        'key': 'apikey',
        'value': localStorage.getItem('apikey'),
        'description': '',
        'req': false
      },
      {
        'key': 'pkey',
        'value': localStorage.getItem('partnerKey'),
        'description': '',
        'req': false
      },
      {
        'key': 'partner',
        'value': localStorage.getItem('partner'),
        'description': '',
        'req': false
      },
      {
        'key': 'database',
        'value': '',
        'description': '',
        'req': false
      }
    ],
    'requestBody': {
      'value': '',
      'key': 'payload',
      'description': 'Document in DATAQL format',
      'annotation': 'RequestBody'
    },
    prerequisites: null,
    authModel: {
      'authAttributes': {}
    }
  };

  constructor(public route: ActivatedRoute,
              public platform: LeftpanelComponent,
              private kong: KongService,
              public accountInfoService: AccountInfoService,
              private router: Router,
              private dialog: MatDialog,
              private confPost: ConfService,
              public footer: FooterComponent) {
  }

  async ngOnInit() {

    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    this.defaultGatewayHost = await this.kong.getDefaultGatewayURL();
    // this.initializeData();

    this.executor.apiUrl = 'https://' + this.defaultGatewayHost + '/' + this.dataQlApiVersion + '/' + this.dataQlApiName;

    const permissionSubscription = interval(500).subscribe((async x => {
      if (this.accountInfoService.hasPermissionsLoaded()) {
        permissionSubscription.unsubscribe();
        this.tabData = [];
        this.route.queryParams.subscribe(params => {
          if (params) {
            if (params.showDoc) {
              this.paramsTobeSent = params;
              this.showDoc = true;
            } else {
              this.addTab(params);
              this.showDoc = false;
            }
          }
        });

        Promise.resolve(this.checkIfGatewayURLExists().then(response => {
          this.gatewayUrlExists = true;
          this.componentLoading = false;
        }, error => {
          this.gatewayUrlExists = false;
          this.componentLoading = false;
        }));
      }
    }));
  }

  // initializeData() {
  //   if (this.footer.docData) {
  //     this.docData = this.footer.docData;
  //     this.getData();
  //
  //   } else {
  //     this.confPost.getData('services', 'services', 'v1', 'referenceDocs', null).subscribe(res => {
  //       this.docData = res;
  //       this.footer.docData = this.docData;
  //       this.getData();
  //     });
  //   }
  // }
  // getData() {
  //   for (const item of this.docData) {
  //     if (item.title === 'DATAQL Engine') {
  //       this.data = item;
  //       console.log(this.data);
  //     }
  //   }
  // }

  addTab(params = {}) {
    this.tabData.push({method: '', apiUrl: '', params: params});
    this.activeTabIndex = this.tabData.length - 1;
  }

  closeTab(index) {
    this.tabData.splice(index, 1);
    this.activeTabIndex = this.tabData.length - 1;
  }

  tabNameChanged(tabName, index) {
    this.tabData[index].method = tabName.method;
    this.tabData[index].apiUrl = tabName.apiUrl;
  }

  checkIfGatewayURLExists() {
    return new Promise((resolve, reject) => {
      this.kong.getServicesFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + this.dataQlApiName + '-' + this.dataQlApiVersion).subscribe(gatewayService => {
        if (gatewayService) {
          resolve('success');
        } else {
          reject('failed');
        }
      }, error => {
        if (error.status === 404) {
          reject(error);
        } else {
          this.platform.openSnackBar('Error while loading the DATAQL Engine. Please try again after sometime.', 'Error', {
            duration: 7000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.router.navigateByUrl('/controlplane');
          resolve('failed');
        }
      });
    });
  }

  async setupGatewayForDATAQLEngine() {
    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '135vw',
      maxHeight: '60vh',
      data: {
        message: 'DATAQL Engine installation is under progress. Please don\'t close the window'
      }
    });
    this.gatewayUrlDeploying = true;
    await this.platform.configureGateway(this.partner, this.account, this.dataQlApiName, this.dataQlApiVersion, 'https', environment.apihostname, '/v1/dataql', 443, ['POST'], false);

    Promise.resolve(this.checkIfGatewayURLExists().then(response => {
      this.gatewayUrlExists = true;
      this.componentLoading = false;
      this.gatewayUrlDeploying = false;
      loaderDialog.close();
    }, error => {
      this.platform.openSnackBar('Error while installing the DATAQL Engine. Please try again after sometime.', 'Error', {
        duration: 7000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.gatewayUrlExists = false;
      this.componentLoading = false;
      this.gatewayUrlDeploying = false;
      loaderDialog.close();
    }));
  }

}
